import { render, staticRenderFns } from "./ReportsApplications.vue?vue&type=template&id=327c9fe5&scoped=true&"
import script from "./ReportsApplications.vue?vue&type=script&lang=js&"
export * from "./ReportsApplications.vue?vue&type=script&lang=js&"
import style0 from "./ReportsApplications.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./ReportsApplications.vue?vue&type=style&index=1&id=327c9fe5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c9fe5",
  null
  
)

export default component.exports